import React from "react"

import { LockClosedIcon } from "@heroicons/react/24/solid"
import Tippy from "@tippyjs/react"

import classNames from "src/classNames"

type MuteButtonProps = {
  connected: boolean
  muted: boolean
  toggleMute: () => void
  controlsLocked?: boolean
  microphoneName: string
}

const MuteButton: React.FC<MuteButtonProps> = ({
  connected,
  muted,
  toggleMute,
  controlsLocked = false,
  microphoneName,
}) => (
  <Tippy content={`Microphone: ${microphoneName}`}>
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2">
      <button
        type="button"
        onClick={toggleMute}
        disabled={!connected || controlsLocked}
        className={classNames(
          "cursor-pointer rounded-full border-none px-6 py-3 text-lg font-medium text-white shadow-lg disabled:opacity-50",
          !connected || controlsLocked
            ? "cursor-not-allowed bg-gray-400"
            : muted
            ? "bg-red-600"
            : "bg-green-600"
        )}
      >
        {!connected ? "Connecting..." : muted ? "Unmute Myself" : "Mute Myself"}
        {controlsLocked && (
          <LockClosedIcon className="ml-2 h-5 w-5 text-white" />
        )}
      </button>
    </div>
  </Tippy>
)

export default MuteButton
